import React from 'react';
import { resolveMediaUrl } from '../lib/mediaUrls';
import { toSeoImageSrcSet, toSeoImageUrl } from '../lib/seoImages';

type MediaImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  priority?: boolean;
  aspectRatio?: string | number;
};

export default function MediaImage({
  src,
  alt = '',
  title,
  loading,
  decoding,
  fetchPriority,
  sizes,
  srcSet,
  priority = false,
  aspectRatio,
  style,
  ...props
}: MediaImageProps) {
  const resolvedSrc = typeof src === 'string' ? resolveMediaUrl(src) : src;
  const optimizedSrc = typeof resolvedSrc === 'string' ? toSeoImageUrl(resolvedSrc, alt, title) : resolvedSrc;
  const optimizedSrcSet = typeof resolvedSrc === 'string' && !srcSet
    ? toSeoImageSrcSet(resolvedSrc, alt, title)
    : srcSet;
  const composedStyle = aspectRatio !== undefined ? { aspectRatio, ...style } : style;

  return (
    <img
      alt={alt}
      title={title ?? (alt ? alt : undefined)}
      loading={priority ? 'eager' : loading ?? 'lazy'}
      decoding={decoding ?? 'async'}
      fetchPriority={priority ? 'high' : fetchPriority}
      src={optimizedSrc}
      srcSet={optimizedSrcSet}
      sizes={sizes ?? (optimizedSrcSet ? '100vw' : undefined)}
      style={composedStyle}
      {...props}
    />
  );
}
